import _createIconComponent from "./utils/createIconComponent";
const _createIconComponent2 = _interopRequireDefault(_createIconComponent);
import _react from "react";
const _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
const IconStartSolid = (0, _createIconComponent2.default)({
  content: _react2.default.createElement(
    "g",
    null,
    _react2.default.createElement(
      "g",
      { clipPath: "url(#clip0)" },
      _react2.default.createElement("path", {
        d: "M18.073 9.73a1 1 0 0 1 0 1.54L8.639 19.1A1 1 0 0 1 7 18.33V2.67a1 1 0 0 1 1.639-.77l9.434 7.83z",
      })
    ),
    _react2.default.createElement(
      "defs",
      null,
      _react2.default.createElement(
        "clipPath",
        { id: "clip0" },
        _react2.default.createElement("path", {
          fill: "#fff",
          d: "M0 0h22v22H0z",
        })
      )
    )
  ),
  height: 22,
  width: 22,
});
IconStartSolid.displayName = "IconStartSolid";
const _default = IconStartSolid;
export { _default as default };
